<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="false"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    @if (canBeIndeterminate) {
        <sh-form-typed-value-list-complex-base
            [indeterminateMsg]="indeterminateMsg"
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [types]="types"
            [typePlaceholderMsg]="typePlaceholderMsg"
            [valuePlaceholderMsg]="valuePlaceholderMsg"
            [id]="controlId"
            [autocompleteFcts]="autocompleteFcts"
        ></sh-form-typed-value-list-complex-base>
    } @else {
        <sh-form-typed-value-list-base
            [required]="isControlRequired$ | async"
            [formControl]="control"
            [types]="types"
            [typePlaceholderMsg]="typePlaceholderMsg"
            [valuePlaceholderMsg]="valuePlaceholderMsg"
            [id]="controlId"
            [autocompleteFcts]="autocompleteFcts"
        ></sh-form-typed-value-list-base>
    }
</sh-form-group>
